/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RfpDraftsControllerStartRfpMutationResponse, RfpDraftsControllerStartRfpPathParams, RfpDraftsControllerStartRfp400, RfpDraftsControllerStartRfp401, RfpDraftsControllerStartRfp403 } from "../../models/rfpDraftsController/RfpDraftsControllerStartRfp";

function getRfpDraftsControllerStartRfpUrl(id: RfpDraftsControllerStartRfpPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/document-drafts/rfp/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/rfp/:id}
 */
export async function rfpDraftsControllerStartRfp(id: RfpDraftsControllerStartRfpPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RfpDraftsControllerStartRfpMutationResponse, ResponseErrorConfig<RfpDraftsControllerStartRfp400 | RfpDraftsControllerStartRfp401 | RfpDraftsControllerStartRfp403>, unknown>({ method : "POST", url : getRfpDraftsControllerStartRfpUrl(id).url.toString(), ... requestConfig })  
  return res.data
}